import { Component } from '@angular/core';
import {AuthService} from "../../../auth/services/auth.service";
import {NavigationService} from "../../../services/navigation.service";

@Component({
    selector: 'app-top-navigation',
    templateUrl: './top-navigation.component.html',
    styleUrls: ['./top-navigation.component.scss'],
    standalone: false
})
export class TopNavigationComponent {
  constructor(public authService: AuthService, public navigationService: NavigationService) {
  }
}
